import { iconSwitchTransition as n } from "../../../_styles/transitions/icon-switch.cssr.js";
import { c as e, cB as o, cM as c, cE as r, insideModal as a, insidePopover as i } from "../../../_utils/cssr/index.js";
const t = e([
  o("checkbox", `
 font-size: var(--n-font-size);
 outline: none;
 cursor: pointer;
 display: inline-flex;
 flex-wrap: nowrap;
 align-items: flex-start;
 word-break: break-word;
 line-height: var(--n-size);
 --n-merged-color-table: var(--n-color-table);
 `, [c("show-label", "line-height: var(--n-label-line-height);"), e("&:hover", [o("checkbox-box", [r("border", "border: var(--n-border-checked);")])]), e("&:focus:not(:active)", [o("checkbox-box", [r("border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]), c("inside-table", [o("checkbox-box", `
 background-color: var(--n-merged-color-table);
 `)]), c("checked", [o("checkbox-box", `
 background-color: var(--n-color-checked);
 `, [o("checkbox-icon", [
    // if not set width to 100%, safari & old chrome won't display the icon
    e(".check-icon", `
 opacity: 1;
 transform: scale(1);
 `)
  ])])]), c("indeterminate", [o("checkbox-box", [o("checkbox-icon", [e(".check-icon", `
 opacity: 0;
 transform: scale(.5);
 `), e(".line-icon", `
 opacity: 1;
 transform: scale(1);
 `)])])]), c("checked, indeterminate", [e("&:focus:not(:active)", [o("checkbox-box", [r("border", `
 border: var(--n-border-checked);
 box-shadow: var(--n-box-shadow-focus);
 `)])]), o("checkbox-box", `
 background-color: var(--n-color-checked);
 border-left: 0;
 border-top: 0;
 `, [r("border", {
    border: "var(--n-border-checked)"
  })])]), c("disabled", {
    cursor: "not-allowed"
  }, [c("checked", [o("checkbox-box", `
 background-color: var(--n-color-disabled-checked);
 `, [r("border", {
    border: "var(--n-border-disabled-checked)"
  }), o("checkbox-icon", [e(".check-icon, .line-icon", {
    fill: "var(--n-check-mark-color-disabled-checked)"
  })])])]), o("checkbox-box", `
 background-color: var(--n-color-disabled);
 `, [r("border", `
 border: var(--n-border-disabled);
 `), o("checkbox-icon", [e(".check-icon, .line-icon", `
 fill: var(--n-check-mark-color-disabled);
 `)])]), r("label", `
 color: var(--n-text-color-disabled);
 `)]), o("checkbox-box-wrapper", `
 position: relative;
 width: var(--n-size);
 flex-shrink: 0;
 flex-grow: 0;
 user-select: none;
 -webkit-user-select: none;
 `), o("checkbox-box", `
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 height: var(--n-size);
 width: var(--n-size);
 display: inline-block;
 box-sizing: border-box;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color 0.3s var(--n-bezier);
 `, [r("border", `
 transition:
 border-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 border-radius: inherit;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border: var(--n-border);
 `), o("checkbox-icon", `
 display: flex;
 align-items: center;
 justify-content: center;
 position: absolute;
 left: 1px;
 right: 1px;
 top: 1px;
 bottom: 1px;
 `, [e(".check-icon, .line-icon", `
 width: 100%;
 fill: var(--n-check-mark-color);
 opacity: 0;
 transform: scale(0.5);
 transform-origin: center;
 transition:
 fill 0.3s var(--n-bezier),
 transform 0.3s var(--n-bezier),
 opacity 0.3s var(--n-bezier),
 border-color 0.3s var(--n-bezier);
 `), n({
    left: "1px",
    top: "1px"
  })])]), r("label", `
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 user-select: none;
 -webkit-user-select: none;
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 `, [e("&:empty", {
    display: "none"
  })])]),
  // modal table header checkbox
  a(o("checkbox", `
 --n-merged-color-table: var(--n-color-table-modal);
 `)),
  // popover table header checkbox
  i(o("checkbox", `
 --n-merged-color-table: var(--n-color-table-popover);
 `))
]);
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/checkbox/src/styles/index.cssr.js
// module id = 1643
// module chunks = 67